import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import { View, Text } from 'react-native'
import Svg, { Defs, ClipPath, Polygon, Line, G } from 'react-native-svg'
import { useTheme } from '@/contexts/ThemeContext'

const STRIPE_Y = [15, 30, 45, 60, 75, 90, 105, 120, 135]

type Props = {
  width?: number
  showText?: boolean
}

export default function TurbinaLogo({ width = 70, showText = true }: Props) {
  const { t } = useTranslation()
  const { isDark } = useTheme()
  const logoColor = isDark ? '#E8732A' : '#1c1c1c'
  // useId gives a stable, unique ID per instance — no collision on remount
  const uid = useId().replace(/:/g, '')
  const clipId = `turbinaTriClip_${uid}`

  return (
    <View
      style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}
      accessible
      accessibilityLabel={t('common.turbinaLogo')}
    >
      <Svg width={width} height={width} viewBox="0 0 200 220">
        <Defs>
          <ClipPath id={clipId}>
            <Polygon points="100,10 10,140 196,148" />
          </ClipPath>
        </Defs>

        <G clipPath={`url(#${clipId})`}>
          {STRIPE_Y.map((y) => (
            <Line key={y} x1="0" y1={y} x2="200" y2={y} stroke={logoColor} strokeWidth="7" />
          ))}
        </G>

        <Polygon points="100,66 38,168 162,168" fill={logoColor} />
      </Svg>
      {showText && (
        <Text
          style={{
            color: isDark ? '#FFFFFF' : '#E8732A',
            fontSize: 22,
            fontWeight: '500',
            letterSpacing: 1,
            fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
          }}
        >
          Turbina
        </Text>
      )}
    </View>
  )
}
